import { render, staticRenderFns } from "./baseAirplaneContainer.vue?vue&type=template&id=23563c89&"
import script from "./baseAirplaneContainer.vue?vue&type=script&lang=js&"
export * from "./baseAirplaneContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23563c89')) {
      api.createRecord('23563c89', component.options)
    } else {
      api.reload('23563c89', component.options)
    }
    module.hot.accept("./baseAirplaneContainer.vue?vue&type=template&id=23563c89&", function () {
      api.rerender('23563c89', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Information/components/basicData/baseAirplaneContainer.vue"
export default component.exports